module.exports = __webpack_public_path__ + "static/nutrient_sugarcane-5567af10671f8ac2891d124482e6755e.png";